import React from "react";
import TooltipWrapper from "../../TooltipWrapper";
import Image from "../../Tags/Image";
import { Cross2Icon, InfoCircledIcon } from "@radix-ui/react-icons";
import { Check } from "lucide-react";

export default function ResponseTable({ tableHeads, tableRows, type = "success" }) {
  const getInitials = (name = "") => {
    if (!name) return "";

    const words = name.trim().split(/\s+/); // split by spaces
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    }

    return (words[0][0] + words[1][0]).toUpperCase();
  };
  return (
    <>
      {tableRows && tableRows.length > 0 && (
        <div className="border border-gray-300 rounded-md overflow-x-scroll mt-5">
          {type === "success" && (
            <div className="p-4 bg-[#DCFAE6] border-b border-[#47CD89] flex items-center min-w-full">
              <Check
                className="text-white bg-green-700 rounded-md p-1 border-box mr-2"
                width={24}
                height={24}
              />
              <span>{tableRows.length} contacts created successfully.</span>
            </div>
          )}
          {type === "error" && (
            <div className="p-4 bg-[#FEE4E2] border-b border-[#FDA29B] flex items-center">
              <InfoCircledIcon
                className="text-white bg-red-500 rounded-md p-1 border-box mr-2"
                width={24}
                height={24}
              />
              <span>Error logged while creating {tableRows.length} contacts</span>
            </div>
          )}
          <table className="w-full border-collapse text-sm text-left">
            <thead className="bg-gray-100 text-gray-700 font-semibold">
              <tr>
                <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre">
                  Name
                </th>
                {tableHeads &&
                  tableHeads.length > 0 &&
                  tableHeads.map((th) => (
                    <th className="px-4 py-2 border-b border-gray-300 border-r border-gray-200 whitespace-pre">
                      {th?.label}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody>
              {tableRows &&
                tableRows.length > 0 &&
                tableRows.map((item, index) => (
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-2 border-b border-r border-gray-200">
                      <div className="flex items-center whitespace-pre">
                        {!item?.isRevealed && (
                          <TooltipWrapper content="No contact details">
                            <Image
                              src="/images/icons/untitledui/alert-warning-outline.svg"
                              className="mr-3 max-w-none"
                            />
                          </TooltipWrapper>
                        )}
                        <div className="inline-flex items-center">
                          <div className="h-9 w-9 flex-shrink-0 items-center bg-gray-100 border border-border justify-center inline-flex rounded-full text-xs">
                            {getInitials(`${item?.first_name} ${item?.last_name}`)}
                          </div>
                          <div className="ml-4">
                            <div className="font-bold text-gray-800">
                              {item?.first_name} {item?.last_name}{" "}
                            </div>
                            <div className="mt-0 text-gray-500">{item?.job_title}</div>
                          </div>
                        </div>
                      </div>
                    </td>
                    {tableHeads &&
                      tableHeads.length > 0 &&
                      tableHeads.map((th) => (
                        <td className="px-4 py-2 border-b border-r border-gray-200">
                          <span className="inline-block border border-transparent whitespace-pre">
                            {item[th?.key] || "-"}
                          </span>
                        </td>
                      ))}
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
